import { memo, useContext } from 'react';
import { useFieldArray } from 'react-hook-form';

import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { GetOptionTranslationMap } from 'constants/guidelineRules';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import PhotoModelField from '../../photoModelField';

const PhotoModelFullField = () => {
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const photoModelFull = useFieldArray({
    control: guidelineRuleFormMethods.control,
    name: GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
  });

  const decrement = () => {
    photoModelFull.remove(photoModelFull.fields.length - 1);
  };

  const increment = () => {
    photoModelFull.append({
      value: '',
    });
  };

  return (
    <PhotoModelField
      label={GetOptionTranslationMap(
        GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
      )}
      count={photoModelFull.fields.length}
      border
      decrement={decrement}
      increment={increment}
    />
  );
};

export default memo(PhotoModelFullField);
